import type { SVGProps } from 'react'
const LineBed = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			d="M22 13.75c0-1.065-.61-1.99-1.5-2.445V7.75A2.755 2.755 0 0 0 17.75 5H6.25A2.755 2.755 0 0 0 3.5 7.75v3.555c-.89.455-1.5 1.38-1.5 2.445V19h1.5v2H5v-2h14v2h1.5v-2H22zM11.25 11H5v-.25c0-.69.56-1.25 1.25-1.25H10c.69 0 1.25.56 1.25 1.25zM19 11h-6.25v-.25c0-.69.56-1.25 1.25-1.25h3.75c.69 0 1.25.56 1.25 1.25zM6.25 6.5h11.5c.69 0 1.25.56 1.25 1.25v.555A2.7 2.7 0 0 0 17.75 8H14c-.79 0-1.5.335-2 .87-.5-.535-1.21-.87-2-.87H6.25c-.45 0-.875.11-1.25.305V7.75c0-.69.56-1.25 1.25-1.25m14.25 11h-17v-3.75c0-.69.56-1.25 1.25-1.25h14.5c.69 0 1.25.56 1.25 1.25z"
		/>
	</svg>
)
export { LineBed }
